import React, { Component, Fragment } from "react";
import { getLoggedInUser } from "../../../MainPage/UserInfo";
import { CRUDFunction } from "../../../../reduxCURD/container";
import ConfirmationDialog from "../../../../libraries/ConfirmationDialog";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import permissionCheck from "../../../../utils/permissionCheck";
import { ToastService } from "../../../../utils/toastify";
import { withRouter } from "react-router-dom";

const user = getLoggedInUser();

class CertifyTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      certifiedBy: this.props.certifiedBy,
      confirmationDialog: null,
      denyConfirmationDialog: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "CERTIFYTEST_UPDATE_SUCCESS") {
      ToastService.Success(
        this.props.CertifyTest && this.props.CertifyTest.certifiedBy ? "Certified Successfully" : "Denied Successfully",
      );
      this.props.handleCertifyClick();
    }

    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "CERTIFYTEST_UPDATE_FAILURE") {
      ToastService.Error("Error:", this.props.CertifyTest && this.props.CertifyTest.certifiedBy ? "Certify Error" : "Deny Error");
      this.props.handleCertifyClick();
    }
  }

  certifyTest = () => {
    const dataToSend = {
      userId: user._id.toString(),
      testIds: this.props.testIds,
      performedByUserId: this.props.selectedPerformedByUser,
    };

    this.props.updateCertifyTest(dataToSend, "certifyTest");
    this.closeConfirmationDialog();
  };

  denyTest = () => {
    const dataToSend = {
      userId: user._id.toString(),
      testIds: this.props.testIds,
      performedByUserId: this.props.selectedPerformedByUser,
    };

    this.props.updateCertifyTest(dataToSend, "denyCertifyTest");
    this.closeDenyConfirmationDialog();
  };

  openConfirmationDialog = () => {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title="Confirm"
          body={<Fragment>Are you sure you want to certify?</Fragment>}
          action="certify"
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={this.certifyTest}
        />
      ),
    });
  };

  openDenyConfirmationDialog = () => {
    this.setState({
      denyConfirmationDialog: (
        <ConfirmationDialog
          title="Confirm"
          body={
            <Fragment>
              Are you sure you want to deny certification?
              <br />
              <br />
              <b>Note:</b> Denied certification entries and their inspection reports will be permanently removed from the system.
            </Fragment>
          }
          action="deny"
          cancelCallback={this.closeDenyConfirmationDialog}
          confirmationCallback={this.denyTest}
        />
      ),
    });
  };

  closeConfirmationDialog = () => {
    this.setState({ confirmationDialog: null });
  };

  closeDenyConfirmationDialog = () => {
    this.setState({ denyConfirmationDialog: null });
  };

  shouldDisableCertify() {
    const { userList, allowDisable, selectedPerformedByUser } = this.props;
    const isSelfUser = (userList || []).some((u) => u.id === user._id.toString());
    const allowCertify = permissionCheck("BLUECARD", "certify");
    const allowSelfCertify = permissionCheck("BLUECARD SELF CERTIFY", "self_certify");

    if (allowDisable && !selectedPerformedByUser) {
      return true;
    }

    if (isSelfUser) {
      return !allowSelfCertify;
    }

    // Non-self user must have general BLUECARD certify permission
    return !allowCertify;
  }

  shouldDisableDeny() {
    const { userList, allowDisable, selectedPerformedByUser } = this.props;
    const allowDeny = permissionCheck("BLUECARD", "deny_certify");
    return !allowDeny;
  }

  render() {
    const disableCertify = this.shouldDisableCertify();
    const certifiedByNameToShow = this.props.hideCertifiedName
      ? ""
      : this.state.certifiedBy && this.state.certifiedBy.name
        ? this.state.certifiedBy.name
        : this.state.certifiedBy;
    return (
      <div>
        {this.state.confirmationDialog}
        {this.state.denyConfirmationDialog}
        {this.state.certifiedBy ? ( //if certified then show certified by name
          certifiedByNameToShow
        ) : (
          <div>
            <MyButton
              className="no-print blueCardFooterReport"
              style={{
                backgroundColor: "var(--nine)",
                borderRadius: "5px",
                padding: "1px 15px",
                marginBottom: "4px",
                fontSize: "18px",
                marginRight: "5px",
              }}
              onClick={this.openConfirmationDialog}
              disabled={disableCertify}
            >
              Certify
            </MyButton>
            <MyButton
              className="no-print blueCardFooterReport"
              style={{ backgroundColor: "#dc3545", borderRadius: "5px", fontSize: "18px", padding: "1px 15px", marginBottom: "4px" }}
              onClick={this.openDenyConfirmationDialog}
              disabled={this.shouldDisableDeny()}
            >
              Deny
            </MyButton>
          </div>
        )}
      </div>
    );
  }
}

let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
};

const CertifyTestContainer = CRUDFunction(CertifyTest, "CertifyTest", actionOptions, null, null, "blueCard");

export default withRouter(CertifyTestContainer);



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/CertifyTest/CertifyTests.jsx